import * as c from "@yahshi/contracts";
import { createAdminRequest, type AdminHttpOptions } from "../../../lib/adminHttp";

export interface CommerceOrderApi {
  list(query?: Partial<c.AdminCommerceOrderListQuery>): Promise<c.AdminCommerceOrderListResult>;
  get(orderId: string): Promise<c.AdminCommerceOrderDetail>;
  transition(orderId: string, input: c.TransitionCommerceOrderInput): Promise<c.AdminCommerceOrderDetail>;
  settleExternal(orderId: string, input: c.SettleExternalCommerceOrderInput): Promise<c.AdminCommerceOrderDetail>;
  updateTitleUg(orderId: string, input: c.UpdateCommerceOrderTitleUgInput): Promise<c.AdminCommerceOrderDetail>;
}

const qs = (value: object) => new URLSearchParams(Object.entries(value).map(([key, item]) => [key, String(item)])).toString();

export function createHttpCommerceOrderApi(options: AdminHttpOptions): CommerceOrderApi {
  const request = createAdminRequest(options);
  return {
    list: (query = {}) => request(`/admin/orders?${qs(c.adminCommerceOrderListQuerySchema.parse(query))}`, c.adminCommerceOrderListResultSchema),
    get: (orderId) => request(`/admin/orders/${encodeURIComponent(orderId)}`, c.adminCommerceOrderDetailSchema),
    transition: (orderId, input) => request(`/admin/orders/${encodeURIComponent(orderId)}/transition`, c.adminCommerceOrderDetailSchema, {
      method: "POST",
      body: JSON.stringify(c.transitionCommerceOrderInputSchema.parse(input)),
    }),
    settleExternal: (orderId, input) => request(`/admin/orders/${encodeURIComponent(orderId)}/settle-external`, c.adminCommerceOrderDetailSchema, {
      method: "POST",
      body: JSON.stringify(c.settleExternalCommerceOrderInputSchema.parse(input)),
    }),
    updateTitleUg: (orderId, input) => request(`/admin/orders/${encodeURIComponent(orderId)}/title-ug`, c.adminCommerceOrderDetailSchema, {
      method: "POST",
      body: JSON.stringify(c.updateCommerceOrderTitleUgInputSchema.parse(input)),
    }),
  };
}
